import script from "./Popular.vue?vue&type=script&setup=true&lang=js"
export * from "./Popular.vue?vue&type=script&setup=true&lang=js"

import "./Popular.vue?vue&type=style&index=0&id=2332e66c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2332e66c"]])

export default __exports__